import { useLazyQuery, useQuery } from '@apollo/client';
import pdca_t_pdcaQueries from '../../queries/pdca_t_pdca.queries';
import { FETCH_T_PDCAS } from '../../queries/pdca_t_pdca.queries.type';
import { useCallback, useEffect } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { FETCH_M_LG_CONFIG } from '@/main/queries/setting_m_lg_config.queries.type';
import setting_m_lg_configQueries from '@/main/queries/setting_m_lg_config.queries';

type UseJigyoListContainer = () => {
    data: FETCH_T_PDCAS | undefined;
    lgConfigData: FETCH_M_LG_CONFIG | undefined;
    onNavigate: (jigyoID: string) => void;
    urlParams: { lgcode: string; jigyoYear: string };
};

/**
 * 事業一覧ページのContainerカスタムフック
 * @returns
 */
export const useJigyoListContainer = () => {
    const { lgcode, jigyoYear }: { lgcode: string; jigyoYear: string } = useParams();
    const history = useHistory();

    const { data: lgConfigData } = useQuery<FETCH_M_LG_CONFIG>(setting_m_lg_configQueries.FETCH_M_LG_CONFIG, {
        variables: { lgcode },
        fetchPolicy: 'cache-first',
    });

    // 事業データ取得の準備
    const [loadJigyoData, { data }] = useLazyQuery<FETCH_T_PDCAS>(pdca_t_pdcaQueries.FETCH_T_PDCAS, {
        // variables: { lgcode, createdYear: Number(jigyoYear) + 1, jigyoYear: Number(jigyoYear), processCd: 10 },
        onError: (error) => console.error(error.message),
        fetchPolicy: 'cache-first',
    });

    // lgConfigDataが取得できたらjigyoDataを取得
    useEffect(() => {
        const lgConfig = lgConfigData?.setting_m_lg_config[0];
        const createdYearCfg = lgConfig?.created_year;
        if (!createdYearCfg) {
            return;
        }

        const year = Number(jigyoYear);
        // 当年度(created_year)は常に予算(processCd=30)。
        // 前年度(created_year - 1)は決算確定フラグ(is_kessan_confirmed)がtrueになるまで予算のままで、
        // 確定した時点(9月頃)で決算(processCd=10)に切り替わる。それより前の年度は常に決算。
        // 予算データは対象年度の前年に作成され、決算データは対象年度の翌年に作成されるため、
        // createdYearは設定値ではなく表示年度(jigyoYear)を基準に算出する。
        const isYosan = year === createdYearCfg || (year === createdYearCfg - 1 && !lgConfig?.is_kessan_confirmed);
        const processCd = isYosan ? 30 : 10;
        const createdYear = isYosan ? year - 1 : year + 1;

        loadJigyoData({
            variables: {
                lgcode,
                createdYear,
                jigyoYear: year,
                jigyoYearPrev: year - 1,
                processCd,
            },
        });
    }, [lgConfigData, lgcode, jigyoYear]);

    // // 事業一覧データ取得
    // const { data } = useQuery<FETCH_T_PDCAS>(pdca_t_pdcaQueries.FETCH_T_PDCAS, {
    //     variables: { lgcode, createdYear: Number(jigyoYear) + 1, jigyoYear: Number(jigyoYear), processCd: 10 },
    //     onError: (error) => console.error(error.message),
    //     fetchPolicy: 'cache-first',
    // });

    /**
     * 画面推移
     * @param jigyoID
     */
    const onNavigate = useCallback(
        (jigyoID: string) => {
            history.push({
                pathname: `/jigyodetail/${lgcode}/${jigyoYear}/${jigyoID}`,
                state: {
                    // master_list: master_list,
                    // id_list: id_list,
                    // menucd: menucd,
                },
            });
        },
        [history, lgcode, jigyoYear]
    );
    return { data, onNavigate, lgConfigData, urlParams: { lgcode, jigyoYear } };
};
